import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";
import { useAppSelector } from "store";

type Filter = {
  value: string | number;
  label: string;
};

interface Props {
  filterByTitle: string;
  onFilterSearchByTitle: (e: string) => void;
  handleApply: () => void;
  onFilterByGeo: (e: Filter[]) => void;
  filterByGeo: Filter[];
  onFilterByActive: (e: Filter[]) => void;
  filterByActive: Filter[];
}
const CmsMainTextFilter: React.FC<Props> = ({
  handleApply,
  onFilterSearchByTitle,
  filterByTitle,
  onFilterByGeo,
  filterByGeo,
  onFilterByActive,
  filterByActive,
}) => {
  const { t } = useTranslation();
  const geoList = useAppSelector((state) => state["settings"].geoList);
  const [geo, setGeo] = useState<Filter[]>([]);

  // const handleSelectType = (
  //   e: Filter[],
  // ) => {

  //   if (e.length === 0 || e[0].value === NotificationEmailTypes.all) {
  //     onFilterByCountry([]);

  //     return
  //   }

  //   onFilterByType(e);
  // };

  const handleApplyFilters = () => {
    handleApply();
  };

  const handleClearFilters = () => {
    onFilterByGeo([]);
    onFilterByActive([]);
    onFilterSearchByTitle("");
    handleApply();
  };

  const handleSelectActive = (e: Filter[]) => {
    if (e[0]?.value === 3) {
      onFilterByActive([]);

      return;
    }

    onFilterByActive(e);
  };

  const handleApplyGeo = (selectedValues: Filter[], isDelete?: boolean) => {
    onFilterByGeo(
      isDelete ? selectedValues : [...filterByGeo, ...selectedValues]
    );
  };

  useEffect(() => {
    const geos = geoList.map((g) => ({
      value: g,
      label: g,
    }));

    setGeo(geos);
  }, [geoList]);

  return (
    <Filter
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("title"),
          boxTitle: t("title"),
          icon: gridIcon,
          inputValue: filterByTitle,
          setInputValue: onFilterSearchByTitle,
          inputPlaceholder: t("title"),
          inputType: "text",
        },
        {
          type: FilterItemTypes.radio,
          title: t("isActive"),
          boxTitle: t("isActive"),
          icon: gridIcon,
          itemsArray: [
            {
              label: "Active",
              value: 1,
            },
            {
              label: "Inactive",
              value: 0,
            },
            {
              label: "All",
              value: 3,
            },
          ],
          activeItems: filterByActive.length
            ? filterByActive
            : [{ label: "All", value: 3 }],
          handleApply: handleSelectActive,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("geo"),
          boxTitle: t("geo"),
          icon: gridIcon,
          itemsArray: geo,
          activeItems: filterByGeo,
          handleApply: handleApplyGeo,
          disabled: geo.length === 0,
        },
      ]}
    />
  );
};

export default CmsMainTextFilter;
